// src/components/common/BlueltBrandMark.tsx
// Logo institucional Bluelt em line-art, portado 1:1 de
// src/assets/images/icon.svg (19 polígonos) para SVG inline. Inline — e não
// <img> — para que o CSS possa animar o stroke de cada linha (efeito
// "circuit flow", Chunk 2 Opção B do Plano-Busy-Overlay). A geometria é
// preservada 1:1 do asset original; cor, stroke e animação vivem em
// BusyOverlay.css. Se o icon.svg mudar, re-portar os polígonos a partir dele.

interface BlueltBrandMarkProps {
  className?: string;
}

const BlueltBrandMark = ({ className }: BlueltBrandMarkProps) => (
  <svg
    className={className}
    viewBox="0 0 275 275"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
      <polygon
        className="circuit-path"
        points="115,206 115,198 113,193 111,192 111,189 107,187 99,187 83,196 70,198 78,199 95,192 99,188 107,188 112,193 114,205 112,210 105,217 111,214"
        style={{ animationDelay: '0.00s' }}
      />
      <polygon
        className="circuit-path"
        points="174,178 174,181 176,182 176,212 174,213 174,215 178,216 179,213 177,211 177,182 179,180 178,178"
        style={{ animationDelay: '0.06s' }}
      />
      <polygon
        className="circuit-path"
        points="217,167 213,167 213,170 215,171 215,187 211,191 211,205 209,207 210,211 213,210 211,206 211,193 216,187"
        style={{ animationDelay: '0.12s' }}
      />
      <polygon
        className="circuit-path"
        points="155,127 154,129 156,131 161,133 163,137 173,144 187,158 187,202 185,206 188,207 188,156 185,155 178,147 167,138 159,129 159,127"
        style={{ animationDelay: '0.18s' }}
      />
      <polygon
        className="circuit-path"
        points="141,127 142,131 144,131 149,137 151,137 165,151 167,155 170,155 169,152 163,149 161,145 145,131 144,127"
        style={{ animationDelay: '0.24s' }}
      />
      <polygon
        className="circuit-path"
        points="157,101 157,104 163,110 166,111 168,115 174,120 174,135 196,156 196,201 194,205 197,206 199,205 197,203 197,156 175,135 175,119 159,105"
        style={{ animationDelay: '0.30s' }}
      />
      <polygon
        className="circuit-path"
        points="82,85 79,87 77,92 77,98 81,104 90,109 114,109 119,114 119,124 111,131 99,131 94,129 88,129 80,134 78,138 71,140 55,138 47,147 47,155 56,164 63,164 55,162 48,153 50,145 55,140 61,139 66,141 73,141 91,130 107,133 116,130 120,126 120,112 116,108 92,108 85,105 79,99 78,94"
        style={{ animationDelay: '0.36s' }}
      />
      <polygon
        className="circuit-path"
        points="149,77 147,78 147,80 149,81 149,107 156,115 160,117 162,122 164,122 166,120 159,116 150,106 151,78"
        style={{ animationDelay: '0.42s' }}
      />
      <polygon
        className="circuit-path"
        points="159,68 156,68 156,73 159,71"
        style={{ animationDelay: '0.48s' }}
      />
      <polygon
        className="circuit-path"
        points="163,65 161,68 163,70 163,85 187,108 186,129 189,130 190,127 188,126 188,108 164,85 164,70 166,69 166,66"
        style={{ animationDelay: '0.54s' }}
      />
      <polygon
        className="circuit-path"
        points="181,62 179,64 182,68 181,82 206,107 206,122 204,127 208,127 208,125 206,124 206,106 182,82 183,63"
        style={{ animationDelay: '0.60s' }}
      />
      <polygon
        className="circuit-path"
        points="189,61 189,65 191,67 190,80 215,105 215,120 213,124 214,126 217,126 216,105 191,80 192,61"
        style={{ animationDelay: '0.66s' }}
      />
      <polygon
        className="circuit-path"
        points="173,61 174,87 198,110 198,133 201,133 199,127 199,109 175,86 175,65 177,64 177,61"
        style={{ animationDelay: '0.72s' }}
      />
      <polygon
        className="circuit-path"
        points="195,52 199,51 205,60 201,61 199,57 195,54"
        style={{ animationDelay: '0.78s' }}
      />
      <polygon
        className="circuit-path"
        points="164,45 162,45 161,49 158,51 156,55 150,59 151,61 154,60 155,56 164,47"
        style={{ animationDelay: '0.84s' }}
      />
      <polygon
        className="circuit-path"
        points="161,37 157,37 156,42 154,43 151,49 144,56 141,57 142,60 144,60 147,53"
        style={{ animationDelay: '0.90s' }}
      />
      <polygon
        className="circuit-path"
        points="118,34 119,36 122,36 123,38 127,39 132,43 132,51 130,53 124,51 117,51 110,56 110,66 112,67 114,72 114,78 112,82 108,84 108,86 111,85 115,79 115,70 111,64 111,57 119,52 123,52 132,59 132,140 124,147 118,149 108,149 107,147 102,147 94,141 94,143 97,146 100,146 101,148 118,149 121,151 119,152 118,156 118,174 119,179 121,180 124,188 123,211 126,203 126,189 122,181 122,178 120,177 120,173 118,172 118,158 127,146 131,147 132,221 127,226 111,235 106,235 104,237 96,237 94,235 86,233 79,227 77,223 92,214 103,202 101,202 89,215 86,215 85,217 78,220 70,220 63,217 52,204 53,192 58,192 59,190 63,190 64,188 68,188 83,181 89,177 91,173 95,170 100,170 107,176 107,174 104,171 95,168 95,156 90,152 83,152 73,156 63,154 66,157 74,157 75,155 86,153 91,154 94,157 94,164 92,170 85,178 79,180 78,182 62,189 58,189 56,191 47,191 41,183 40,175 42,173 60,173 67,171 40,171 34,161 33,145 39,130 41,129 41,123 44,115 55,120 67,120 79,117 96,117 104,120 98,116 77,116 57,119 48,116 43,109 49,98 54,93 54,84 56,82 56,79 62,72 67,69 87,69 92,76 93,92 99,96 107,96 116,93 120,88 120,85 112,94 97,94 93,88 92,72 87,68 83,67 68,67 67,61 75,49 78,49 79,47 85,47 88,45 96,45 96,43 107,34"
        style={{ animationDelay: '0.96s' }}
      />
      <polygon
        className="circuit-path"
        points="156,33 164,34 165,36 170,38 176,45 190,45 191,47 193,47 196,56 211,72 213,77 217,81 218,93 222,97 222,144 203,160 204,201 201,205 203,207 206,205 204,203 204,161 223,143 223,101 224,100 228,106 230,126 239,143 239,159 235,168 233,169 233,173 231,175 231,183 229,187 225,191 223,190 223,163 227,159 232,157 232,155 229,154 228,157 222,162 222,193 220,195 220,202 218,204 217,209 210,217 207,217 203,220 196,222 188,231 177,237 163,237 162,235 158,235 145,228 144,226 141,226 138,222 138,186 140,184 152,193 151,217 155,217 155,215 153,214 153,193 138,181 139,165 142,166 162,186 162,205 160,207 160,210 164,210 164,207 162,206 162,184 158,182 138,161 138,149 140,148 162,169 164,174 167,173 167,171 159,166 155,161 151,159 150,156 144,150 140,148 138,144 138,137 142,137 152,148 155,149 162,156 168,165 170,164 170,161 164,158 137,131 139,42 145,36"
        style={{ animationDelay: '1.02s' }}
      />
      <polygon
        className="circuit-path"
        points="199,46 191,42 179,41 173,35 160,29 146,32 140,35 137,39 132,39 131,37 122,32 110,30 102,33 92,42 77,44 68,51 63,64 53,77 49,93 42,101 42,104 40,106 38,126 33,134 33,137 31,138 31,143 29,145 29,157 31,159 31,164 33,165 33,168 36,173 37,181 42,192 47,195 50,206 55,216 64,222 73,225 86,238 97,240 114,238 135,225 136,227 138,227 147,234 150,234 154,238 158,238 165,241 175,241 186,238 200,225 210,221 219,214 225,196 232,190 234,186 236,174 243,159 243,143 241,141 240,134 234,124 232,105 230,104 229,99 221,87 221,81 219,80 217,73 208,63 208,59 206,58 204,51"
        style={{ animationDelay: '1.08s' }}
      />
  </svg>
);

export default BlueltBrandMark;
